import React, { FC, ReactElement, useEffect, useRef } from 'react';

const styles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  backgroundColor: 'white',
}

const DefaultPage: FC = (): ReactElement => {
  const video = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      (window as any).comdiLoader.createPlayer(video.current);
    }, 0);
  }, []);
  
  return (
    <div className="default-page" style={styles as any}>
      <div className="" style={{width: '100%', maxWidth: '600px'}}>
        <div id="comdi-player" data-comdi-event="e6yhrcf2" ref={video} />
      </div>
    </div>
  );
};

export default DefaultPage;
